export default __webpack_public_path__ + "images/66ca73abca3fbac57c97a030213d69a4-Icon.jpg";